<div class="duzlem-kontrol-container">

    <!-- Plane List -->
    <div style="display: flex;">
        <button class="ui icon mini button"
                style="padding: 0.25rem;margin-left:auto;"
                [disabled]="kesitDuzlemleri.length >= 6"
                (click)="yeniDuzlemEkle()"
                title="Yeni Düzlem">
            <i class="icon plus" style="font-size: 10px;"></i>
        </button>
    </div>
    <div class="plane-section">
        <div class="plane-list">
            <div *ngFor="let duzlem of kesitDuzlemleri; let i = index"
                 class="plane-item"
                 [class.active]="aktifDuzlemIndex === duzlem.id"
                 (click)="aktifDuzlemDegistir(duzlem.id)">
                <span class="plane-name">{{ duzlem.isim }}</span>
                <button  class="ui icon mini button"
                *ngIf="kesitDuzlemleri.length > 1"
                style="padding: 0.2rem;margin-left:auto;"
                (click)="duzlemSil(duzlem.id); $event.stopPropagation()"
                title="Yeni Düzlem">
            <i class="icon trash" style="font-size: 11px;"></i>
        </button>
            </div>
        </div>
    </div>


        <!-- Action Buttons -->
        <div class="button-row">
            <button class="btn-primary icon-only"
                    (click)="hareketDialogAc()"
                    title="Hareket ve dönme kontrollerini aç">
                <i class="icon move"></i>
            </button>
    
            <button class="btn-secondary icon-only"
                    (click)="duzlemInverse()"
                    title="Kesit yönünü ters çevir (180°)">
                <i class="icon exchange"></i>
            </button>
    
            <button class="btn-select icon-only"
                    [class.active]="dinamikKesit.yuzeySecimAktif"
                    (click)="yuzeySecimToggle()"
                    title="Bir yüzeye tıklayarak kesit düzlemini ayarla">
                <i class="icon target"></i>
            </button>
    
            <button class="btn-secondary icon-only"
                    (click)="duzlemYuzeyMerkezineTasi()"
                    title="Seçili yüzeyin merkezine taşı">
                <i class="icon surface-center"></i>
            </button>
    
            <button class="btn-secondary icon-only"
                    (click)="duzlemSahneMerkezineTasi()"
                    title="Sahne merkezine taşı">
                <i class="icon scene-center"></i>
            </button>
    
            <button class="btn-reset icon-only"
                    (click)="tumDuzlemleriSifirla()"
                    title="Sıfırla">
                <i class="icon refresh"></i>
            </button>
        </div>

        <!-- Visibility Toggle Buttons -->
        <div class="button-row visibility-row">
            <button class="btn-toggle icon-only"
                    [class.active]="dinamikKesit.halkaGorunur"
                    (click)="halkaGorunurlukToggle()"
                    title="Döndürme halkalarını göster/gizle">
                <i class="icon ring"></i>
            </button>

            <button class="btn-toggle icon-only"
                    [class.active]="dinamikKesit.gridGorunur"
                    (click)="gridGorunurlukToggle()"
                    title="Grid düzlemini göster/gizle">
                <i class="icon grid"></i>
            </button>

            <button class="btn-toggle icon-only"
                    [class.active]="dinamikKesit.kesitCizgisiGorunur"
                    (click)="kesitCizgisiGorunurlukToggle()"
                    title="Kesit çizgilerini göster/gizle">
                <i class="icon section-line"></i>
            </button>

            <button class="btn-toggle icon-only"
                    [class.active]="dinamikKesit.okGorunur"
                    (click)="okGorunurlukToggle()"
                    title="Taşıma oklarını göster/gizle">
                <i class="icon arrow"></i>
            </button>

            <button class="btn-toggle icon-only"
                    [class.active]="dinamikKesit.eksenGorunur"
                    (click)="eksenGorunurlukToggle()"
                    title="Eksenleri göster/gizle">
                <i class="icon axes"></i>
            </button>
        </div>

        <!-- Kontur Export (2D teknik resim) -->
        <div class="button-row export-row">
            <button class="btn-toggle icon-only"
                    (click)="konturAktar('dxf')"
                    title="Kesit konturunu DXF olarak dışa aktar">
                <i class="icon download"></i> DXF
            </button>
            <button class="btn-toggle icon-only"
                    (click)="konturAktar('svg')"
                    title="Kesit konturunu SVG olarak dışa aktar">
                <i class="icon download"></i> SVG
            </button>
        </div>
</div>